/**
 * Contact form prefills via /contact?reason=…&topic=… (and optional location.state).
 * reason: contact | quote | appointment (aliases normalized in normalizeContactReason)
 */
export const CONTACT_PRESETS = {
  contact: {
    subject: 'General inquiry',
    message:
      "I'd like to get in touch with ShawnyMedia.\n\nWhat I'm looking for:\n\n",
  },
  quote: {
    subject: 'Quote request',
    message:
      "I'd like a quote for the following:\n\n• Project or service:\n• Ideal timeline:\n• Budget range (optional):\n\nDetails:\n",
  },
  appointment: {
    subject: 'Book a consultation',
    message:
      "I'd like to book a free consultation.\n\nPreferred days/times:\n\nWhat I'd like to discuss:\n\n",
  },
};

export function normalizeContactReason(raw) {
  if (raw == null) return null;
  const r = String(raw).toLowerCase().trim();
  if (!r) return null;
  if (['quote', 'estimate', 'pricing'].includes(r)) return 'quote';
  if (
    ['appointment', 'consult', 'consultation', 'book', 'booking', 'meeting', 'schedule'].includes(r)
  ) {
    return 'appointment';
  }
  if (['contact', 'general', 'inquiry', 'message'].includes(r)) return 'contact';
  if (CONTACT_PRESETS[r]) return r;
  return null;
}

export function getContactPreset(reasonKey) {
  if (!reasonKey || !CONTACT_PRESETS[reasonKey]) return null;
  return CONTACT_PRESETS[reasonKey];
}
